export default __webpack_public_path__ + "static/media/plateChow.0da0f29c.svg";